module.exports = __webpack_public_path__ + "6ed951fca437da140de9bce51daad1a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/B_W3.jpg
// module id = 3303
// module chunks = 0